"use client";

import Link from "next/link";
import LazyImage from "src/lib/components/salify-next-layout/default/components/LazyImage";
import {
  ContentWrapper,
  FeaturedImgBox,
  StyledHorizontalCard,
} from "src/lib/components/product-item/vertical/styles";
import { H2, Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography";
import Box from "@mui/material/Box";
import { FlexBox } from "src/lib/components/salify-next-layout/default/components/flex-box";
import { formatMoney, toAssetImages } from "src/lib/utils";
import DiscountChip from "src/lib/components/salify-next-layout/default/components/product-cards/discount-chip";

// ============================================================
const ProductItemHorizontal = (props: any) => {
  const featuredBgImg = props.featuredOption || "misc/featured-background-opt2.png";
  const featuredImgBoxParams = { bgImg: props.isFeature ? featuredBgImg : undefined };
  return (
    <StyledHorizontalCard sx={props.sx}>
      <FeaturedImgBox id="imgBox" {...featuredImgBoxParams}>
        {props.saleOffPercent > 0 && <DiscountChip discount={props.saleOffPercent} />}
        <Link href={`/product/${props.slugName}`}>
          <LazyImage
            alt={props.name}
            width={90}
            height={90}
            src={toAssetImages(props.imageUrl)}
            style={{
              width: 90,
              objectFit: "contain",
            }}
          />
        </Link>
      </FeaturedImgBox>

      <ContentWrapper>
        <Link href={`/product/${props.slugName}`} className="title">
          <H2 mb={1} title={props.name} fontSize={13} fontWeight={600} color="text.secondary">
            {props.name}
          </H2>
        </Link>

        <FlexBox alignItems="center" gap={1}>
          <Paragraph fontWeight={600} color={"warning.900"}>
            {formatMoney(props.salePrice)}
          </Paragraph>

          {props.saleOffPercent ? (
            <Box component="del" fontWeight={600} color="grey.600">
              {formatMoney(props.originalSalePrice)}
            </Box>
          ) : null}
        </FlexBox>
      </ContentWrapper>
    </StyledHorizontalCard>
  );
};

export default ProductItemHorizontal;
